import React, { useState } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { useSelector } from 'react-redux'
import { DateTime } from 'luxon'
import twas from 'twas'

import useWindowDimensions from '../../../hooks/UseWindowDimensions'

import { NOTIFICATION_TYPE_MAP } from '../../../utils/common'

function NotificationItem({notificationId, notificationSelected, className, body, type, users, timestamp, onNotificationClick, as, showImage, headingLevel, showType}){
    const ago = twas(timestamp, Date.now())
    const user = useSelector(state => state.session.user)
    const isAdmin = useSelector(state => state.session.isAdmin)

    const { screenSize } = useWindowDimensions();

    const [popoverToggled, setPopoverToggled] = useState(false)

    const ElementTag = as
    const Header = `h${headingLevel}`
    let classHighlight = ""

    if(notificationSelected?.notificationId === notificationId){
        classHighlight = "active"
    } else if(users === undefined || 
        users[user.userId] === undefined ||
        !users[user.userId].read) {
        
        classHighlight = "unread"
    }

    return <ElementTag href="javascript:;" className={`${className} media ${classHighlight}`} onClick={() => onNotificationClick(notificationId, body.link, {
        notificationId,
        type,
        body,
        timestamp,
        ago
    })}>
        {showImage && <div className="media-left">
            <img src={body.image} className="media-object" />
        </div>}
        <div className="media-body">
            <Header className="media-heading">{body.title} <i className={body.icon}></i></Header>
            <p dangerouslySetInnerHTML={{__html: body.message}}></p>
            <div className="d-flex justify-content-start align-items-center">
                {showType && <span class={`mr-2 badge badge-pill badge-${classHighlight === "active" ? "dark" : (NOTIFICATION_TYPE_MAP[type] ?? "warning")}`} style={{fontSize: "12px"}}>{type}</span>}
                <div id={"item-"+timestamp.toString()} className={`text-${classHighlight.length > 0 ? "black" : "muted"} f-s-10`} >
                    {ago}
                </div>
                <Popover trigger={["sm", "xs"].includes(screenSize) ? "click" : "hover"} popperClassName="bg-black" innerClassName="bg-black" placement="bottom" isOpen={popoverToggled} target={"item-"+timestamp.toString()} toggle={() =>setPopoverToggled(!popoverToggled) }>
                    <PopoverBody className="text-white">
                        {DateTime.fromMillis(timestamp).toFormat("LLL d, yyyy @ h:mm a")}
                    </PopoverBody>
                </Popover>
            </div>
        </div>
    </ElementTag>
}

NotificationItem.defaultProps = {
    className: "",
    as: "a",
    showImage: true,
    showType: false,
    headingLevel: 6
}

export default NotificationItem